(() => {
  'use strict';
  if (window.location.pathname.replace(/\/+$/, '') === '/pages/build-your-tmo-collection') return;
  // Cart drawer suppression intentionally runs only outside the TMO collection builder.
})();
